// axios.ts
import axios from "axios";

import { RUNTIME } from "../config/runtime";

const api = axios.create({ 
    baseURL: RUNTIME.API_URL || "/api",
    headers: { "Content-Type": "application/json" },
    withCredentials: true,
});

api.interceptors.request.use((config) => {
    const token = localStorage.getItem("token");
    if (token) {
        config.headers = {
            ...config.headers,
            Authorization: `Bearer ${token}`,
        };
    }
    return config;
});

api.interceptors.response.use(
    (response) => response, // ✅ keep full response
    (error) => {
        if (error.response?.status === 401) {
            localStorage.removeItem("token");
            // window.location.href = "/login";
        }
        return Promise.reject(error.response?.data || error.message);
    }
);

export default api;
